module.exports = __webpack_public_path__ + "static/media/5.4.c9a3de65.png";